export const PUBLIC_ROUTES = ["/login"];
